<app-access-control-form
[title]="'access_control.form.create_role' | translate"
(submitForm)="handleSubmit($event)"
[submitLoading]="submitLoading">
</app-access-control-form>
